<template>
    <div id="reimbursement-page-tab">
        <!--<vue-tabs @tab-change="handleTabChange" :value="tabValue" active-tab-color="#007bff !important" 
           active-text-color="white">
          <v-tab title="General"></v-tab>
          <v-tab title="Payment"></v-tab>
        </vue-tabs>-->
        <router-view></router-view>
    </div>
</template>

<script>
  import {VTab, VueTabs} from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/vue-tabs.scss'

  export default {
    components: {
      VueTabs,
      VTab
    },
    data () {
      return {
        tabValue: 0
      }
    },
    methods: {
      handleTabChange (tabIndex) {
        this.$router.push({path: !tabIndex ? '/reimbursement/general' : '/reimbursement/payment'})
      }
    },
    mounted () {
      this.tabValue = this.$router.currentRoute.path === '/reimbursement/general' ? 0 : 1
    }
  }
</script>

<style>
  #user-page-tab .card {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  #user-page-tab .vue-tabs .nav-tabs {
    border-bottom: 0 solid #ddd
  }
</style>
